<template>
    <b-modal
        id="file-viewer"
        dialog-class="file-modal"
        header-class="file-modal__header"
        body-class="file-modal__body"
        hide-footer
        @hidden="reset"
    >
        <template #modal-header="{ close }">
            <div class="file-modal__title text-truncate">
                <b>Наименование документа:</b> {{ file.name }}
            </div>

            <div class="d-flex align-items-center">
                <form method="get" :action="file.downloadLink">
                    <b-button class="d-flex" type="submit">
                        Скачать
                        <i class="ml-2 fas fa-download"></i>
                    </b-button>
                </form>

                <b-icon-x
                    class="ml-3 cursor-pointer"
                    @click="close"
                    font-scale="2"
                ></b-icon-x>
            </div>
        </template>

        <template v-if="!file.error.message.length > 0">
            <template v-if="isImage">
                <img class="file-modal__image" :src="file.src" />
            </template>
            <template v-if="isPdf">
                <vue-pdf-embed
                    @loading-failed="
                        error(
                            'Ошибка чтения файла, попробуйте снова, либо обратитесь к администратору'
                        )
                    "
                    :source="file.src"
                />
            </template>
            <template v-if="isOfficeDocument">
                <div class="file-modal__office">
                    <iframe
                        width="100%"
                        height="100%"
                        :src="file.src"
                        name="imgbox"
                        frameborder="0"
                    ></iframe>
                </div>
            </template>
        </template>
        <template v-else>
            <div class="file-modal__error">
                <span>{{ file.error.message }}</span>
                <b-icon-cloud-slash class="mt-3" font-scale="5"></b-icon-cloud-slash>
            </div>
        </template>
    </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
export default {
    components: {
        VuePdfEmbed,
    },

    watch: {
        "file.src": {
            handler(value) {
                if (value.length > 0) {
                    this.$bvModal.show("file-viewer");
                }
            },
        },
    },

    computed: {
        ...mapGetters("fileViewer", ["file"]),

        isImage() {
            const extentions = ["jpg", "png", "gif"];
            return extentions.some((e) => e === this.file.extention);
        },

        isPdf() {
            const extentions = ["pdf"];
            return extentions.some((e) => e === this.file.extention);
        },

        isOfficeDocument() {
            const extentions = ["xlsx", "xls", "doc", "docx", "pptx", "ppt"];
            return extentions.some((e) => e === this.file.extention);
        },
    },

    methods: {
        ...mapActions("fileViewer", ["reset", "error"]),
    },
};
</script>

<style lang="scss">
.file-modal {
    max-width: 1250px;

    &__title {
        font-size: 1rem;
    }

    &__header {
        position: sticky;
        top: 0;
        z-index: 999;
        display: flex;
        align-items: center;
        padding: 10px 1rem;
    }

    &__body {
        text-align: center;
        min-height: 80vh;
    }

    &__image {
        width: 100%;
        height: 80vh;
        object-fit: contain;
    }

    &__office {
        height: 80vh;
    }

    &__error {
        font-size: 1.5rem;
        height: 80vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}
</style>
